import {
    SET_ORDER_APPROVAL_REQUEST,
    SET_APPROVAL_REQUEST_OPTION_,
    SET_QUANTITY_APPROVAL_OPTION,
    SET_SELECTED_OPTIONS_SUBMIT,
    SET_FINAL_SAVE_APPROVAL_MANAGEMENT,
    SET_IS_OVERRIDE_ACTION_APPLICABLE
} from "./OrderApprovalType";

const initialState = {
    orderApprovalRequest: {
        orderId: 0,
        approverEmailId: '',
        approverActionId: 0,
        comment: '',
        requestApproveVMs: []
    },
    approvalRequestOption: {},
    quantityApprovalOption: [],
    selectedOptionsSubmit: [],
    isOverrideActionapplicable: false
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ORDER_APPROVAL_REQUEST:
            return {
                ...state,
                orderApprovalRequest: action.orderApprovalRequest,
            };
            case SET_APPROVAL_REQUEST_OPTION_:
            return {
                ...state,
                approvalRequestOption: action.approvalRequestOption,
            };
            case SET_QUANTITY_APPROVAL_OPTION:
            return {
                ...state,
                quantityApprovalOption: action.quantityApprovalOption,
            };
            case SET_SELECTED_OPTIONS_SUBMIT:
            return {
                ...state,
                selectedOptionsSubmit: action.selectedOptionsSubmit,
            };
            case SET_FINAL_SAVE_APPROVAL_MANAGEMENT:
            return {
                ...state,
                finalSaveApprovalManagement: action.finalSaveApprovalManagement,
            };
            case SET_IS_OVERRIDE_ACTION_APPLICABLE:
            return {
                ...state,
                isOverrideActionapplicable: action.isOverrideActionapplicable,
            };
        default:
            return state;
    }
};

export default reducer;
